<script lang="ts" setup>
import config from '@/config/ConfigProvider';
import { SecureLogin } from '@ilteducation/ilt-auth';
import { useMyOrganizations } from '@ilteducation/my-account';

const serviceName = config.value('serviceName');
const clientId = config.value('authClientId');
const basePath = config.value('basePath');

const { reset: resetMyOrganizations } = useMyOrganizations(false);

const onBeforeExchanginCode = () => {
  resetMyOrganizations();
};
</script>

<template>
  <SecureLogin
    :client-id="clientId"
    :service-name="serviceName"
    :base-path="basePath"
    :on-before-exchanging-code="onBeforeExchanginCode"
  ></SecureLogin>
</template>
